export default __webpack_public_path__ + "static/media/spa.5e1065fa.png";